import { useField } from '@adflow/frontend/util-common';

import type { FormControlProps } from '../FormControl';
import { FormControl } from '../FormControl';

import type { CheckboxProps } from './Checkbox';
import { Checkbox } from './Checkbox';

export type CheckboxWithControlProps = {
	name: string;
	/**
	 * If present, this function will be called when the checkbox is clicked.
	 * If the function returns `false`, the checkbox will not change.
	 */
	beforeChange?: (newValue: boolean) => boolean;
	onChangeEffect?: (newValue: boolean) => void;
	formControl?: boolean;
} & CheckboxProps &
	FormControlProps;

export function CheckboxWithControl(
	props: CheckboxWithControlProps & { formControl?: boolean }
): JSX.Element {
	const {
		name,
		beforeChange,
		onChangeEffect,
		formControl,
		outerStyle,
		innerStyle,
		label,
		infoText,
		tooltipText,
		labelStyle,
		helperText,
		helperStyle,
		helperTextStyle,
		helperExtra,
		error,
		className,
		...other
	} = props;

	const {
		field: { ref, value, onChange },
	} = useField({ name });

	if (formControl) {
		return (
			<FormControl
				label={label}
				labelStyle={labelStyle}
				helperText={helperText}
				helperStyle={helperStyle}
				error={error}
				outerStyle={outerStyle}
				infoText={infoText}
				innerStyle={[
					{
						marginLeft: '1rem',
					},
					innerStyle,
				]}
				tooltipText={tooltipText}
				helperTextStyle={helperTextStyle}
				helperExtra={helperExtra}
				className={className}
			>
				<Checkbox
					ref={ref}
					checked={!!value}
					onChange={() => {
						// @ts-expect-error `data-*` attributes are not in the type definition
						if (props['data-disabled']) return;
						if (beforeChange && beforeChange(!value) === false) return;
						if (onChangeEffect) onChangeEffect(!value);
						onChange(!value);
					}}
					{...other}
				/>
			</FormControl>
		);
	}

	return (
		<Checkbox
			ref={ref}
			checked={!!value}
			onChange={() => {
				// @ts-expect-error `data-*` attributes are not in the type definition
				if (props['data-disabled']) return;
				if (beforeChange && beforeChange(!value) === false) return;
				if (onChangeEffect) onChangeEffect(!value);
				onChange(!value);
			}}
			{...other}
		/>
	);
}
